import { VariantType } from '@pelicargo/types';

import { trpc, TrpcInputs, TrpcOutputs } from '../../config/trpc';
import { MutateFunction, UseCreateResource } from '../../utils/types';

type QuoteVariantInput = TrpcInputs['createQuoteVariant'];
type QuoteVariantOutput = TrpcOutputs['createQuoteVariant'];

type CreateQuoteVariantMutate = MutateFunction<QuoteVariantInput, QuoteVariantOutput>;
type UseCreateQuoteVariant = UseCreateResource<QuoteVariantInput, QuoteVariantOutput>;

export const useCreateQuoteVariant = (quoteId?: number, type?: VariantType): UseCreateQuoteVariant => {
  const { mutateAsync: createAsync, isLoading, error } = trpc.createQuoteVariant.useMutation();

  const create: CreateQuoteVariantMutate = (args) =>
    createAsync({
      quote_id: quoteId,
      type,
      ...args,
    } as unknown as QuoteVariantInput);
  const createDefault: CreateQuoteVariantMutate = () => {
    createAsync({
      quote_id: quoteId,
      type,
      name: type,
    } as QuoteVariantInput);
  };

  return {
    create,
    createDefault,
    isLoading,
    error: error?.message,
  };
};
